import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { initBlock, reportDWH } from './ServiceAppointmentBlockSlice';
import { hideAppLoader } from '../../Shared/Loader/LoaderSlice';

import ErrorPage from './Pages/ErrorPage/ErrorPage';
import MessagePage from './Pages/MessagePage/MessagePage';
import SubscriberPage from './Pages/SubscriberPage/SubscriberPage';
import ServiceRequestMainPage from './Pages/ServiceRequestMainPage/ServiceRequestMainPage';
import RouterConnectionPage from './Pages/RouterConnectionPage/RouterConnectionPage';
import NumberToReturnPage from './Pages/NumberToReturnPage/NumberToReturnPage';
import TechnicianPage from './Pages/TechnicianPage/TechnicianPage';
import ProgressBar from './Pages/ProgressBar/ProgressBar';
import RestartRouter from './Pages/RestartRouter/RestartRouter';
import TechnicianSuccessPage from './Pages/TechnicianPage/TechnicianSuccessPage';
import AddressPage from './Pages/AddressPage/AddressPage';
import DeliveryPage from './Pages/DeliveryPage/DeliveryPage';
import DeliverySuccessPage from './Pages/DeliveryPage/DeliverySuccessPage';
import arrow from './images/arrow.svg';
import Config from '../../../Config';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';


const Main = (props) => {
  useEffect(() => {
    props.hideAppLoader();
    props.initBlock({
        serviceAppointmentSchedulerBlock: props.iContent,
        getContext: props.context
    });
    props.reportDWH({ actionType: 'InternetFaultWizard Page', status: 'Ongoing', messageText: 'InternetFaultWizard Page Displayed' });
}, []);

useClearStateResetFlag();


let currentView = null;

const handleOnLinkClick = ()=>{
  window.history.back()
};



switch (props.page) {
    case 'errorPage': currentView = <ErrorPage />; break;
    case 'messagePage': currentView = <MessagePage />; break;
    case 'subscribersPage': currentView = <SubscriberPage />; break;
    case 'serviceRequestMainPage': currentView = <ServiceRequestMainPage />; break;
    case 'routerConnectionPage': currentView = <RouterConnectionPage />; break;
    case 'regionalIssuePage': currentView = <RouterConnectionPage />; break;
    case 'progressBar': currentView = <ProgressBar />; break;
    case 'restartRouter': currentView = <RestartRouter />; break;
    case 'numberToReturnPage': currentView = <NumberToReturnPage />; break;
    case 'technicianPage': currentView = <TechnicianPage />; break;
    case 'technicianSuccessPage': currentView = <TechnicianSuccessPage />; break;
    case 'addressPage': currentView = <AddressPage />; break;
    case 'deliveryPage': currentView = <DeliveryPage />; break;
    case 'deliverySuccessPage' : currentView = <DeliverySuccessPage />; break;
};


  return (
    <div className='wrapper-main'>
      {(props.typePage === 'YOUR_INTERNET_STATUS_1_1' ||
      props.typePage === 'NO_INTERNET_CONNECTION_1_1_1' ||
      props.typePage === 'PERFORMING_INTERNET_TEST_PAGE_1_1_1_1' ||
      props.typePage === 'INTERNET_CONNECTION_TYPE_1_1_2' ||
      props.typePage === 'INTERNET_CONNECTION_TYPE_1_1_3' ||
      props.page == 'routerConnectionPage' || props.page == 'addressPage' || props.page == 'deliveryPage') &&
      <div className='wrapper-back-button'>
         <a href='#' className='back-button' onClick={handleOnLinkClick}> <Image src={arrow} alt='icon' /> חזרה </a>
      </div>
      }
      <div className='main-page'>
      {currentView}</div>
    </div>

  );
};

const mapStateToProps = (state) => {
  return {
    page: state.serviceAppointmentSchedulerBlock.page,
    typePage: state.serviceAppointmentSchedulerBlock.typePage,
  };
};

const mapDispatchToProps = { initBlock, reportDWH, hideAppLoader };

export default connect(mapStateToProps, mapDispatchToProps)(Main);
